import React from 'react';

const SvgNo = (props) => (
  <svg width="1em" height="1em" viewBox="0 0 28 20" {...props}>
    <defs>
      <rect id="NO_svg__a" x={0} y={0} width="100%" height="100%" rx={2} />
    </defs>
    <g fill="none" fillRule="evenodd">
      <mask id="NO_svg__b" fill="#fff">
        <use xlinkHref="#NO_svg__a" />
      </mask>
      <rect
        stroke="#F5F5F5"
        strokeWidth={0.5}
        x={0.25}
        y={0.25}
        width={27.5}
        height={19.5}
        rx={2}
      />
      <path
        d="M8 0v8H0V0h8zm4 0h16v8H12V0zm16 12v8H12v-8h16zM8 20H0v-8h8v8z"
        fill="#F14247"
        mask="url(#NO_svg__b)"
      />
      <path
        fill="#0A3A85"
        mask="url(#NO_svg__b)"
        d="M0 10.667h9.333V20h1.334v-9.333H28V9.333H10.667V0H9.333v9.333H0z"
      />
    </g>
  </svg>
);

export default SvgNo;
